import { render, staticRenderFns } from "./DossierEditForm.vue?vue&type=template&id=1c0613d6&"
import script from "./DossierEditForm.vue?vue&type=script&lang=ts&"
export * from "./DossierEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0613d6')) {
      api.createRecord('1c0613d6', component.options)
    } else {
      api.reload('1c0613d6', component.options)
    }
    module.hot.accept("./DossierEditForm.vue?vue&type=template&id=1c0613d6&", function () {
      api.rerender('1c0613d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierEditForm.vue"
export default component.exports